module.exports = __webpack_public_path__ + "img/艺术展厅.db66fef1.png";